export { default as AnalyticsTrendsTable } from './AnalyticsTrendsTable';
